// src/car-colors.ts
// User-selectable car colors. Shared by the home-screen picker (ui-home),
// the map renderer (map-manager), and message validation — peers broadcast
// their chosen color in LocationMessage.color, and receivers only honor
// values from this whitelist so nobody can ship an invisible or garbage
// color to the rest of the room.

export interface CarColor {
  name: string;
  value: string;
}

export const CAR_COLORS: CarColor[] = [
  { name: 'Blue', value: '#2456ff' },
  { name: 'Red', value: '#e6194b' },
  { name: 'Orange', value: '#f58231' },
  { name: 'Yellow', value: '#ffe119' },
  { name: 'Green', value: '#3cb44b' },
  { name: 'Cyan', value: '#42d4f4' },
  { name: 'Purple', value: '#911eb4' },
  { name: 'Magenta', value: '#f032e6' },
  { name: 'Silver', value: '#e0e0e0' },
  { name: 'Brown', value: '#9a6324' },
];

export function isCarColor(value: unknown): value is string {
  return typeof value === 'string' && CAR_COLORS.some(c => c.value === value);
}
